export default __webpack_public_path__ + "static/media/c3.27088727.svg";